module.exports = __webpack_public_path__ + "components/weather-icon/static/nightrisksnow-a235c9f7b5ac8614d682022189472cd5.svg";